import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE;

/**
 * GET /v1/onboarding/paypal/purchase-plans
 */
export function getPurchasePlans() {
  const url = `${API_BASE}onboarding/paypal/purchase-plans`;
  return axios.get(url);
}

/**
 * POST /v1/onboarding/paypal/order
 * @param {{ orderType: number, quantity: number, email: string }} payload
 */
export function createPayPalOrder(payload) {
  const url = `${API_BASE}onboarding/paypal/order`;
  return axios.post(url, payload);
}

/**
 * POST /v1/onboarding/paypal/order/{orderId}/capture?token=...
 */
export function capturePayPalOrder(orderId, token) {
  const url = `${API_BASE}onboarding/paypal/order/${orderId}/capture`;
  return axios.post(url, null, { params: token ? { token } : undefined });
}

/**
 * POST /v1/onboarding/paypal/order/{orderId}/cancel?token=...
 */
export function cancelPayPalOrder(orderId, token) {
  const url = `${API_BASE}onboarding/paypal/order/${orderId}/cancel`;
  return axios.post(url, null, { params: token ? { token } : undefined });
}
